import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsExpand: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.84.16v10.453L5.387.16zM.16 15.84V5.387L10.613 15.84z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsExpand
